import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BasePagingResponse } from "../_types";

export type GetApprovedRejectedChangeRequestListRequest = {
  roleLevel?: number;
  makerUserId?: number;
  startDate?: string;
  endDate?: string;
  status?: string;
}

export type IApprovedRejectedChangeRequest = {
  roleLevel?: number;
  makerUserId?: number;
  startDate?: string;
  endDate?: string;
  status?: string;
}

export type GetApprovedRejectedChangeRequestListResponse = BasePagingResponse<Array<IApprovedRejectedChangeRequest>>;

async function getApprovedRejectedChangeRequestList(data: GetApprovedRejectedChangeRequestListRequest): Promise<GetApprovedRejectedChangeRequestListResponse> {
  try {
    return (await axiosInstance.post("/ChangeRequest/ListApprovedRejected", data))
      .data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetApprovedRejectedChangeRequestList() {
  return useMutation<GetApprovedRejectedChangeRequestListResponse, Error, GetApprovedRejectedChangeRequestListRequest>((variables) =>
    getApprovedRejectedChangeRequestList(variables)
  );
}
